import React from 'react';
import { ExternalLinkIcon } from 'lucide-react';
export function DemoSlide() {
  return <div className="flex flex-col w-screen h-screen overflow-hidden bg-white text-[#1a1a2e] relative" data-id="element-228">
      {/* Subtle background grid pattern */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
      backgroundImage: `radial-gradient(circle, #1a1a2e 1px, transparent 1px)`,
      backgroundSize: '32px 32px'
    }} data-id="element-229" />

      {/* Subtle radial glow behind CTA area */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-[#2EBCB0]/[0.04] blur-3xl" data-id="element-230" />

      {/* Top Header */}
      <div className="flex justify-between items-start shrink-0 px-8 py-6 relative z-10" data-id="element-231">
        <img src="https://cdn.magicpatterns.com/uploads/wGUVVF9ppu2J6VxJ2kpoN3/Pair2_Logo.png" alt="Pair2 Logo" className="h-8 w-auto object-contain" data-id="element-232" />
      </div>

      {/* Main Content — Centered */}
      <div className="flex-grow flex flex-col items-center justify-center relative z-10 px-8 -mt-8" data-id="element-233">
        {/* Section Label */}
        <span className="text-xs font-semibold text-[#2EBCB0] uppercase tracking-widest mb-3" data-id="element-234">
          Live Platform
        </span>

        {/* Title */}
        <h1 className="text-[2.25rem] font-bold text-[#1a1a2e] text-center leading-tight mb-4" data-id="element-235">
          Experience Pair2 in Action
        </h1>

        {/* Subtitle */}
        <p className="text-[1rem] text-gray-500 text-center max-w-xl leading-relaxed mb-10" data-id="element-236">
          See how the platform operates in real time across drivers, vehicles,
          and delivery operations
        </p>

        {/* CTA Button */}
        <a href="https://fms.pair2.ae" target="_blank" rel="noopener noreferrer" className="group inline-flex items-center gap-3 bg-[#2EBCB0] hover:bg-[#28a89e] text-white font-bold text-[1rem] px-10 py-4 rounded-xl shadow-lg shadow-[#2EBCB0]/25 hover:shadow-xl hover:shadow-[#2EBCB0]/30 transition-all duration-300 mb-8" data-id="element-237">
          View Live System Demo
          <ExternalLinkIcon className="w-5 h-5 opacity-80 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-300" data-id="element-238" />
        </a>

        {/* URL */}
        <div className="flex items-center gap-2 mb-4" data-id="element-239">
          <div className="w-2 h-2 rounded-full bg-[#2EBCB0] animate-pulse" data-id="element-240" />
          <span className="text-[1.1rem] font-semibold text-[#1a1a2e] tracking-wide" data-id="element-241">
            fms.pair2.ae
          </span>
        </div>

        {/* Supporting Text */}
        <p className="text-[0.8rem] text-gray-400 text-center max-w-md" data-id="element-242">
          Access the live Pair2 FMS platform and explore its full capabilities
        </p>
      </div>

      {/* Bottom spacer for balance */}
      <div className="shrink-0 h-16" data-id="element-243" />
    </div>;
}